__turbopack_context__.v({
  "UiAvatar": "avatar-module__Yy-zPq__UiAvatar",
});
